/**
 * Utility functions for generating email HTML templates
 */

/**
 * Generates the HTML content for the satisfaction survey email
 * @param {Object} comentario - The comment object containing support ticket details
 * @returns {string} The complete HTML string for the email
 */
export const generateSurveyEmailHtml = (comentario) => {
    
    const titulo = 'Encuesta de Satisfacción';
    const saludo = 'Estimado cliente,';
    const cuerpo = 'Hemos resuelto su consulta de soporte técnico. Para ayudarnos a mejorar nuestros servicios, le invitamos a completar una breve encuesta sobre su experiencia.';
    const link = 'https://forms.gle/MFve7hi3rjF4HHCF7';
    const titulo_link = 'Completar Encuesta';

    // Simplified template based on CorreoOrden.html structure
    return `
<!DOCTYPE html>
<html lang="es">
<head>
    <meta http-equiv="content-type" content="text/html; charset=UTF-8">
    <title>Akasia Software Development S.A. de C.V.</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0">
    <meta name="theme-color" content="#f4f4f4">
    <meta name="msapplication-navbutton-color" content="#f4f4f4">
    <style>
        body { margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif; }
        .container { max-width: 600px; margin: 0 auto; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1); }
        .header { background-color: #1a252f; color: #ffffff; padding: 30px 20px; text-align: center; border-bottom: 3px solid #007bff; }
        .header h1 { margin: 0; font-size: 24px; font-weight: bold; }
        .content { padding: 30px 20px; color: #333333; line-height: 1.6; }
        .details { background-color: #f8f9fa; border-left: 4px solid #007bff; padding: 20px; margin: 20px 0; border-radius: 5px; }
        .details h3 { color: #007bff; margin-top: 0; font-size: 18px; }
        .details ul { list-style: none; padding: 0; }
        .details li { margin-bottom: 10px; padding-left: 25px; position: relative; }
        .details li:before { content: '✓'; color: #28a745; font-weight: bold; position: absolute; left: 0; }
        .cta-button { display: inline-block; background-color: #28a745; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; text-align: center; margin: 20px 0; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
        .cta-button:hover { background-color: #218838; }
        .disclaimer { font-size: 12px; color: #666666; text-align: center; margin: 20px 0; font-style: italic; }
        .footer { background-color: #f8f9fa; padding: 20px; text-align: center; border-top: 1px solid #dee2e6; }
        .social-links { margin: 10px 0; }
        .social-links a { margin: 0 10px; text-decoration: none; }
        .contact-info { font-size: 14px; color: #333333; margin-top: 10px; }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <h1>${titulo}</h1>
        </div>
        <div class="content">
            <p><strong>${saludo}</strong></p>
            <p>${cuerpo}</p>
            <div class="details">
                <h3>🔧 Detalles de su consulta:</h3>
                <ul>
                    <li><strong>👤 Agente que lo atendió:</strong><br> ${comentario.vUsuarioSolucion || 'No especificado'}</li>
                    <li><strong>❓ Problema:</strong><br> ${comentario.vProblema ? comentario.vProblema.replace(/<[^>]*>/g, '').substring(0, 200) + (comentario.vProblema.length > 200 ? '...' : '') : 'No disponible'}</li>
                    <li><strong>✅ Solución:</strong><br> ${comentario.vSolucion ? comentario.vSolucion.replace(/<[^>]*>/g, '').substring(0, 200) + (comentario.vSolucion.length > 200 ? '...' : '') : 'No disponible'}</li>
                    <li><strong>⏱️ Tiempo de resolución:</strong> ${comentario.dTiempo} minutos</li>
                </ul>
            </div>
            <div style="text-align: center;">
                <a href="${link}" class="cta-button">${titulo_link}</a>
            </div>
            <div class="disclaimer">
                <em>No debe responder a este correo ya que nadie lo estará monitoreando. En caso de querer contactar, use el correo: <a href="mailto:contacto@akasia.com.mx">contacto@akasia.com.mx</a></em>
            </div>
        </div>
        <div class="footer">
            <div class="social-links">
                <a href="https://www.facebook.com/akasiapos" target="_blank">
                    <img src="https://prodigia.odoo.com/web/image/107594-f5a08dcc/fb.png" alt="Facebook" style="height: 24px; width: auto;" />
                </a>
                <a href="https://akasia.com.mx" target="_blank">
                    <img src="https://prodigia.odoo.com/web/image/107598-bf0dd33f/web.png" alt="Website" style="height: 24px; width: auto;" />
                </a>
            </div>
            <div class="contact-info">
                <strong>Akasia Software Development S.A. de C.V.</strong><br>
                (332) 197 1397<br>
                <a href="mailto:contacto@akasia.com.mx">contacto@akasia.com.mx</a><br>
                Calle Juan Escutia #17, Col. Centro, El Ceñidor, Municipio de Múgica, 61770 Michoacán.<br>
                El Ceñidor, Michoacán, México.
            </div>
        </div>
    </div>
</body>
</html>
    `;
};